import * as React from 'react';

import Icon from '../Icon';

interface Props {
  size?: number;
  color?: string;
  children?: React.ReactNode;
}

const OnigiriIcon: React.FunctionComponent<Props> = props => {
  const size = props.size || 35;
  const color = props.color || '#1486c2';
  return <Icon name={'support-onigiri'} size={size} color={color} />;
};

export default React.memo(OnigiriIcon);
